<template>
  <PageTitle :title="content.legacy" :parentTitle="content.home">
    <div class="flex items-center">
      <div class="
          bg-primary
          relative
          h-16
          ltr:mr-4
          rtl:ml-4
          lg:min-w-[240px]
          max-w-[170px]
          min-w-[170px]
          sm:min-w-[200px]
          px-4
          flex
          items-center
          justify-between
          cursor-pointer
        " @click="openFilter = !openFilter">
        <div class="
            capitalize
            text-sm
            sm:text-base
            truncate
            px-2
            sm:px-0
            ltr:mr-2
            rtl:ml-2
          ">
          {{ content[$route.query.type] }}
        </div>
        <div>
          <i class="fa fa-chevron-down transition-all duration-300" :class="{ 'rotate-180': openFilter }"></i>
        </div>
        <div class="
            max-h-0
              overflow-hidden
            lg:min-w-[240px]
            min-w-[170px]
            sm:min-w-[200px]
            transition-all
            duration-300
            absolute
            left-0
            top-[74px]
            z-[1]
            bg-primary
          " :class="{ openWorksFilter: openFilter }">
          <router-link to="/legacy?type=all">
            <div v-if="$route.query.type != 'all'" class="
                capitalize
                text-sm
                sm:text-base
                px-4
                flex
                items-center
                h-16
                hover:bg-secondary
                transition-all
                duration-200
                cursor-pointer
              ">
              {{ content.all }}
            </div>
          </router-link>
          <router-link to="/legacy?type=internationalacclaims">
            <div v-if="$route.query.type != 'internationalacclaims'" class="
                capitalize
                text-sm
                sm:text-base
                px-4
                flex
                items-center
                h-16
                hover:bg-secondary
                transition-all
                duration-200
                cursor-pointer
              ">
              {{ content.internationalacclaims }}
            </div>
          </router-link>
          <router-link to="/legacy?type=projects">
            <div v-if="$route.query.type != 'projects'" class="
                capitalize
                text-sm
                sm:text-base
                px-4
                flex
                items-center
                h-16
                hover:bg-secondary
                transition-all
                duration-200
                cursor-pointer
              ">
              {{ content.projects }}
            </div>
          </router-link>
          <router-link to="/legacy?type=exhibitions">
            <div v-if="$route.query.type != 'exhibitions'" class="
                capitalize
                text-sm
                sm:text-base
                px-4
                flex
                items-center
                h-16
                hover:bg-secondary
                transition-all
                duration-200
                cursor-pointer
              ">
              {{ content.exhibitions }}
            </div>
          </router-link>
          <router-link to="/legacy?type=impactonart">
            <div v-if="$route.query.type != 'impactonart'" class="
                capitalize
                text-sm
                sm:text-base
                px-4
                flex
                items-center
                h-16
                hover:bg-secondary
                transition-all
                duration-200
                cursor-pointer
              ">
              {{ content.impactonart }}
            </div>
          </router-link>
          <router-link to="/legacy?type=achievements">
            <div v-if="$route.query.type != 'achievements'" class="
                capitalize
                text-sm
                sm:text-base
                px-4
                flex
                items-center
                h-16
                hover:bg-secondary
                transition-all
                duration-200
                cursor-pointer
              ">
              {{ content.achievements }}
            </div>
          </router-link>
          <router-link to="/legacy?type=projects">
            <div v-if="$route.query.type != 'projects'" class="
                capitalize
                text-sm
                sm:text-base
                px-4
                flex
                items-center
                h-16
                hover:bg-secondary
                transition-all
                duration-200
                cursor-pointer
              ">
              {{ content.projects }}
            </div>
          </router-link>
        </div>
      </div>

      <YearDropdown @setYear="setYear"></YearDropdown>
    </div>
  </PageTitle>
  <div v-if="noResult" class="font-xl layout-padding">
    {{ content.noResultFound }}
  </div>
  <div v-else-if="legacies.length == 0">
    <div class="grid grid-cols-3 layout-padding gap-0 mb-32">
      <div class="col-span-3" v-for="(legacy, index) in 10" :key="index">
        <div class="w-full h-[1px] bg-line bg-opacity-70"></div>

        <div class="
            legacy-card
            group
            h-[250px]
            bg-primary
            flex flex-col
            relative
            z-0
          "></div>
      </div>
      <div class="w-full h-[1px] bg-line col-span-3"></div>
      <div class="col-span-3 flex justify-center my-8"></div>
    </div>
  </div>
  <div class="grid grid-cols-3 layout-padding gap-0 mb-32" v-else>
    <div class="col-span-3" v-for="(legacy, index) in legacies" :key="index">
      <LegacyCard :legacy="legacy" />
    </div>
    <div class="w-full h-[1px] bg-line col-span-3"></div>
    <div class="col-span-3 flex justify-center my-8">
      <div @click="loadData" v-if="!allLegaciesLoaded" class="
          py-4
          px-10
          bg-primary
          text-center
          transition-all
          duration-700
          hover:bg-secondary
          cursor-pointer
          min-w-[216px]
        ">
        {{ content.loadMore }}
      </div>
    </div>
  </div>
</template>

<script>
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);
import LegacyCard from "/src/components/UI/Cards/LegacyCard.vue";
export default {
  inject: ["content"],
  data() {
    return {
      openFilter: false,
      selectedYear: null,
    };
  },
  computed: {
    legacies() {
      return this.$store.getters["legacy/legacy"];
    },
    allLegaciesLoaded() {
      return this.$store.getters["legacy/allLegaciesLoaded"];
    },
    noResult() {
      return this.$store.getters["legacy/noResult"];
    },
  },
  components: {
    LegacyCard,
  },
  methods: {
    loadData() {
      if (this.$route.query.type != "all") {
        let keys = {
          internationalacclaims: "international",
          exhibitions: "exhibitions",
          impactonart: "impact",
          achievements: "achievements",
          projects: "project",
        };
        this.$store.dispatch("legacy/filterLegacy", {
          type: keys[this.$route.query.type],
          year: this.selectedYear == null ? "all" : this.selectedYear,
        });
      } else {
        this.$store.dispatch("legacy/filterLegacy", {
          type: "all",
          year: this.selectedYear == null ? "all" : this.selectedYear,
        });
      }
    },
    setYear(year) {
      this.selectedYear = year;
    },
  },
  watch: {
    "$route.query.type": {
      handler: function () {
        this.$store.dispatch("legacy/resetLegacy");
        this.loadData();
      },
      deep: true,
      immediate: true,
    },
    selectedYear() {
      this.$store.dispatch("legacy/resetLegacy");
      this.loadData();
    },
  },
};
</script>